type FAQ = {
  id: number
  question: string
  answer: string
}

type FAQEnum = {
  benefits: FAQ[]
  general: FAQ[]
}

export const FAQEnum: FAQEnum = {
  benefits: [
    {
      id: 1,
      question: 'How does On-Demand access work with my membership?',
      answer:
        'With the Silver Membership, you receive unlimited access to our On-Demand Classes. These classes are available 24/7, allowing you to learn and practice at your own pace'
    },

    {
      id: 2,
      question: 'What are Teaching Tables, and how do I access them?',
      answer:
        'Teaching Tables are live interactive sessions where you can engage directly with instructors and other members. Silver Members get access to one Teaching Table per month, while Gold Members can attend two Teaching Tables monthly. You can book your spot through the app’s scheduling section.'
    },
    {
      id: 3,
      question: 'How do Live Classes work with the Gold Membership?',
      answer:
        'Premium Members have access to four live classes on demand each month. You can join these sessions from the app, and they are designed to offer real-time instruction and participation.'
    }
  ],
  general: [
    {
      id: 4,
      question: 'How do I manage my membership?',
      answer:
        'To manage your membership, including upgrading or canceling your subscription, visit the "Manage Membership" section in your account settings. You can easily adjust your plan or check billing details from there.'
    },
    {
      id: 8,
      question: 'Can I upgrade from Silver to Gold?',
      answer:
        'Yes! You can upgrade from the Silver Membership to the Gold Membership at any time. Simply navigate to your account settings and choose the upgrade option under "Manage Membership."'
    },
    /*   {
      id: 6,
      question: 'How does the discount for store purchases work?',
      answer:
        'Gold members receive a 15% discount on any purchase made through http://store.pokerpower.com . The discount is automatically applied at checkout as long as you are logged into your premium account.'
    }, */
    {
      id: 7,
      question: 'Can I cancel my membership anytime?',
      answer:
        'Yes, you can cancel your membership at any time without any long-term commitment. Simply go to the "Manage Membership" section in your account settings, and follow the steps to cancel. You will retain access to your membership benefits until the end of your current billing period.'
    }
  ]
}
